import ModalWrapper from "../../common/ModalWrapper";
import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const CategoryFormModal = ({
  mode = "create",
  API,
  open,
  onClose,
  onSuccess,
  initialData = null,
}) => {
  const [form, setForm] = useState({
    name: "",
    description: "",
    image: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);

  useEffect(() => {
    if (open) {
      setForm({
        name: initialData?.name || "",
        description: initialData?.description || "",
        image: initialData?.image || "",
      });
    }
  }, [open, initialData]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name.trim()) {
      return toast.error("Category name is required");
    }

    try {
      setSubmitting(true);

      let res;
      if (mode === "create") {
        res = await axios.post(`${API}/job-category/create`, form);
      } else {
        res = await axios.post(
          `${API}/job-category/update/${initialData._id}`,
          form,
        );
      }

      if (res.data.success) {
        toast.success(
          mode === "create"
            ? "Category created successfully"
            : "Category updated successfully",
        );
        onSuccess?.();
        onClose();
      }
    } catch (error) {
      console.error("Category submit error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

    try {
      setUploadingImage(true);
      const res = await axios.post(
        process.env.REACT_APP_CLOUDINARY_IMAGE_UPLOAD_URL,
        formData
      );
      if (res.data && res.data.secure_url) {
        setForm((prev) => ({ ...prev, image: res.data.secure_url }));
        toast.success("Image uploaded successfully");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload image");
    } finally {
      setUploadingImage(false);
      e.target.value = "";
    }
  };

  return (
    <ModalWrapper
      title={mode === "create" ? "Create Job Category" : "Edit Job Category"}
      onClose={onClose}
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Category Name
          </label>
          <input
            type="text"
            value={form.name}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, name: e.target.value }))
            }
            className="w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 focus:ring-primaryBtnColor"
            placeholder="Enter category name"
          />
        </div>

        {/* Cloudinary image upload only */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Category Image
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileUpload}
            disabled={uploadingImage}
            className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
          />
          {uploadingImage && (
            <p className="text-sm text-blue-500 mt-1">Uploading...</p>
          )}
          {form.image && !uploadingImage && (
            <p className="text-sm text-green-600 mt-1">Image uploaded ✓</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Description
          </label>
          <textarea
            rows={5}
            value={form.description}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, description: e.target.value }))
            }
            className="w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 focus:ring-primaryBtnColor resize-none"
            placeholder="Enter description"
          />
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-100 text-primaryTextColor py-2.5 px-6 rounded-lg hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={submitting}
            className="bg-primaryBtnColor text-white py-2.5 px-6 rounded-lg hover:bg-primaryBtnHoverColor disabled:opacity-70"
          >
            {submitting
              ? mode === "create"
                ? "Creating..."
                : "Updating..."
              : mode === "create"
                ? "Create Category"
                : "Update Category"}
          </button>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default CategoryFormModal;







// import ModalWrapper from "../../common/ModalWrapper";
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";

// const CategoryFormModal = ({
//   mode = "create",
//   API,
//   open,
//   onClose,
//   onSuccess,
//   initialData = null,
// }) => {
//   const [form, setForm] = useState({
//     name: "",
//     description: "",
//     image: "",
//   });
//   const [submitting, setSubmitting] = useState(false);

//   useEffect(() => {
//     if (open) {
//       setForm({
//         name: initialData?.name || "",
//         description: initialData?.description || "",
//         image: initialData?.image || "",
//       });
//     }
//   }, [open, initialData]);

//   if (!open) return null;

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.name.trim()) {
//       return toast.error("Category name is required");
//     }

//     try {
//       setSubmitting(true);

//       let res;
//       if (mode === "create") {
//         res = await axios.post(`${API}/job-category/create`, form);
//       } else {
//         res = await axios.post(
//           `${API}/job-category/update/${initialData._id}`,
//           form
//         );
//       }

//       if (res.data.success) {
//         toast.success(
//           mode === "create"
//             ? "Category created successfully"
//             : "Category updated successfully"
//         );
//         onSuccess?.();
//         onClose();
//       }
//     } catch (error) {
//       console.error("Category submit error:", error);
//       toast.error(error?.response?.data?.message || "Something went wrong");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <ModalWrapper
//       title={mode === "create" ? "Create Job Category" : "Edit Job Category"}
//       onClose={onClose}
//     >
//       <form onSubmit={handleSubmit} className="space-y-5">
//         <div>
//           <label className="block text-sm font-semibold text-gray-700 mb-2">
//             Category Name
//           </label>
//           <input
//             type="text"
//             value={form.name}
//             onChange={(e) =>
//               setForm((prev) => ({ ...prev, name: e.target.value }))
//             }
//             className="w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 focus:ring-primaryBtnColor"
//             placeholder="Enter category name"
//           />
//         </div>

//         <div>
//           <label className="block text-sm font-semibold text-gray-700 mb-2">
//             Image URL
//           </label>
//           <input
//             type="text"
//             value={form.image}
//             onChange={(e) =>
//               setForm((prev) => ({ ...prev, image: e.target.value }))
//             }
//             className="w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 focus:ring-primaryBtnColor"
//             placeholder="Paste image URL"
//           />
//         </div>

//         <div>
//           <label className="block text-sm font-semibold text-gray-700 mb-2">
//             Description
//           </label>
//           <textarea
//             rows={5}
//             value={form.description}
//             onChange={(e) =>
//               setForm((prev) => ({ ...prev, description: e.target.value }))
//             }
//             className="w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 focus:ring-primaryBtnColor resize-none"
//             placeholder="Enter description"
//           />
//         </div>

//         <div className="flex justify-end gap-3">
//           <button
//             type="button"
//             onClick={onClose}
//             className="bg-gray-100 text-primaryTextColor py-2.5 px-6 rounded-lg hover:bg-gray-200"
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={submitting}
//             className="bg-primaryBtnColor text-white py-2.5 px-6 rounded-lg hover:bg-primaryBtnHoverColor disabled:opacity-70"
//           >
//             {submitting
//               ? mode === "create"
//                 ? "Creating..."
//                 : "Updating..."
//               : mode === "create"
//               ? "Create Category"
//               : "Update Category"}
//           </button>
//         </div>
//       </form>
//     </ModalWrapper>
//   );
// };

// export default CategoryFormModal;